import { render, staticRenderFns } from "./InputDay.vue?vue&type=template&id=24ca2d32"
import script from "./InputDay.vue?vue&type=script&lang=js"
export * from "./InputDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports